export class ResponsePlanGestionConvivencia{
    payload:PlanGestionConvivenciaModel;

    constructor(){
        this.payload = new PlanGestionConvivenciaModel();
    }
}

export class PlanGestionConvivenciaModel{    
    id:number;
    idJardinPeriodo:number;
    diagnostico:string;
    estrategias:EstrategiaModel[];
    fechaElavoracion:Date;
    fechaActualizacion:Date;
    unidadEducativa:string;
    comuna:string;
    region:string;
    aprobado:string;
    anio:number;
    responsable:string;

    constructor(){
        this.id = -1;
        this.idJardinPeriodo = -1;
        this.diagnostico = "";
        this.estrategias = new Array<EstrategiaModel>();
        this.unidadEducativa = "";
        this.comuna = "";
        this.region = "";
        this.aprobado = "";
        this.responsable = "";
    }
}

export class EstrategiaModel{    

    id:number;
    estrategia:string;
    actividades:ActividadModel[];
    constructor(){
        this.id = -1;
        this.estrategia = "";
        this.actividades = new Array<ActividadModel>();
    }
}

export class ActividadModel{    

    id:number;
    actividad:string;
    objetivo:string; 
    descripcion:string; 
    lugar:string; 
    responsable:string; 
    medioVerificacion:string; 
    fechaDesde:Date;
    fechaHasta:Date;
    constructor(){
        this.id = -1;
        this.actividad = "";
        this.objetivo = "";
        this.descripcion = "";
        this.lugar = "";
        this.responsable = "";
        this.medioVerificacion = "";
    }
}

